var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7265",
    "data-name": "Group 7265",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.771,
    height: 10.105,
    viewBox: "0 0 16.771 10.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5312",
    "data-name": "Path 5312",
    d: "M8.385,10.105a1.715,1.715,0,0,1-1.216-.5L.5,2.936A1.72,1.72,0,0,1,2.936.5L8.385,5.953,13.835.5a1.72,1.72,0,1,1,2.432,2.432L9.6,9.6A1.715,1.715,0,0,1,8.385,10.105Z",
    transform: "translate(0 0)",
    fill: "#7b86fa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.89e27243883917d97e8593160482cf29.svg";
export { ForwardRef as ReactComponent };